import React from 'react';
import classNames from 'classnames';

import styles from './Tabs.module.scss';

interface TabListProps {
  children: React.ReactNode;
  className?: string;
}

export function TabList({ children, className }: TabListProps) {
  return (
    <div className={classNames(styles.tabList, className)} role="tablist">
      {children}
    </div>
  );
}
